import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-bold text-gray-800 mb-8">Política de Privacidad</h1>
          
          <p className="text-gray-600 mb-6">
            <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES')}
          </p>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Información General</h2>
              <p className="text-gray-600 leading-relaxed">
                Innova2Market, con domicilio en España, es responsable del tratamiento de los datos personales 
                que nos proporciones a través de nuestros servicios de automatización e inteligencia artificial. 
                Nos comprometemos a proteger tu privacidad y a tratar tus datos personales de manera transparente y segura.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Datos que Recopilamos</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Recopilamos únicamente los datos necesarios para proporcionar nuestros servicios:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Datos de contacto (nombre, email, teléfono)</li>
                <li>Información de la empresa (nombre, sector, tamaño)</li>
                <li>Datos técnicos necesarios para la implementación de soluciones de IA</li>
                <li>Información de uso de nuestros servicios (logs de sistema, métricas de rendimiento)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Finalidad del Tratamiento</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Utilizamos tus datos personales para:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Proporcionar y mejorar nuestros servicios de automatización e IA</li>
                <li>Comunicarnos contigo sobre tu proyecto y soporte técnico</li>
                <li>Enviar información relevante sobre nuestros servicios (solo con tu consentimiento)</li>
                <li>Cumplir con obligaciones legales y contractuales</li>
                <li>Analizar y optimizar el rendimiento de nuestras soluciones</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Base Legal</h2>
              <p className="text-gray-600 leading-relaxed">
                El tratamiento de tus datos se basa en la ejecución del contrato de servicios, 
                el cumplimiento de obligaciones legales, nuestros intereses legítimos para mejorar 
                nuestros servicios, y tu consentimiento cuando sea requerido por ley.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Conservación de Datos</h2>
              <p className="text-gray-600 leading-relaxed">
                Conservamos tus datos personales durante el tiempo necesario para cumplir con las 
                finalidades descritas y las obligaciones legales aplicables. Los datos se eliminarán 
                de forma segura una vez que ya no sean necesarios.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Seguridad</h2>
              <p className="text-gray-600 leading-relaxed">
                Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos 
                personales contra el acceso no autorizado, la alteración, divulgación o destrucción. 
                Utilizamos cifrado, controles de acceso y auditorías regulares de seguridad.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Tus Derechos</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Tienes derecho a:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Acceder a tus datos personales</li>
                <li>Rectificar datos inexactos o incompletos</li>
                <li>Solicitar la eliminación de tus datos</li>
                <li>Limitar el tratamiento de tus datos</li>
                <li>Portabilidad de datos</li>
                <li>Oponerte al tratamiento</li>
                <li>Retirar tu consentimiento en cualquier momento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Transferencias Internacionales</h2>
              <p className="text-gray-600 leading-relaxed">
                En caso de realizar transferencias internacionales de datos, nos aseguraremos de que 
                se realicen con las garantías adecuadas y en cumplimiento de la normativa aplicable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Cookies y Tecnologías Similares</h2>
              <p className="text-gray-600 leading-relaxed">
                Nuestro sitio web no utiliza cookies de seguimiento. Solo utilizamos cookies técnicas 
                estrictamente necesarias para el funcionamiento del sitio web.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Contacto</h2>
              <p className="text-gray-600 leading-relaxed">
                Para ejercer tus derechos o para cualquier consulta sobre esta política de privacidad, 
                puedes contactarnos en:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg mt-4">
                <p className="text-gray-700">
                  <strong>Email:</strong> info@innova2market.es<br/>
                  <strong>Teléfono:</strong> +34 604 97 16 08
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Modificaciones</h2>
              <p className="text-gray-600 leading-relaxed">
                Nos reservamos el derecho de modificar esta política de privacidad. Te notificaremos 
                cualquier cambio significativo a través de nuestros canales habituales de comunicación.
              </p>
            </section>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
